import { create } from 'zustand';
import {
  defaultLanguage,
  Design,
  DesignChannelType,
  LanguageCode,
  TextToSpeechVoiceOrDefault,
  Voice
} from '../types';

export type GlobalSettings = {
  /** Channel code for prompt nodes to display the text for. */
  channel: DesignChannelType | null;
  /** Language code for prompt nodes to display the text for. */
  language: LanguageCode;
  /** Same as value from @see useDesign. */
  serialized: Design | null;
  /** Map of language codes to TTS voices or (@see defaultTtsVoice) to use for audio generation since some languages have multiple TTS voices. */
  ttsVoices: Record<LanguageCode, TextToSpeechVoiceOrDefault>;
  /** Voice code for prompt nodes to display the text for. */
  voice: Voice | null;
};

type GlobalSettingsActions = {
  setSettings: <K extends keyof GlobalSettings>(
    updates: Pick<GlobalSettings, K>
  ) => void;
};

const useGlobalSettings = create<GlobalSettings & GlobalSettingsActions>(
  (set) => ({
    channel: null,
    language: defaultLanguage,
    serialized: null,
    ttsVoices: {},
    voice: null,
    setSettings: (updates) => set((state) => ({ ...state, ...updates }))
  })
);

const getGlobalSettings = () => useGlobalSettings.getState();
const setGlobalSettings = (params: Parameters<GlobalSettingsActions['setSettings']>[0]) => {
  return useGlobalSettings.getState().setSettings(params);
};

export { useGlobalSettings, getGlobalSettings, setGlobalSettings };
